import Vue from 'vue';
const state = {
    bill: {
        items: [],
        supplier: {},
        distributor: {}
    },
    bills: {
        data: []
    },
}
const actions = {
    showBills: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/bills`).then(response => {
                context.commit('SHOW_BILLS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showBill: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/bills/${id}`).then(response => {
                context.commit('SHOW_BILL', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeBill: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/bills`, payload).then(response => {
                context.commit('STORE_BILL', response.data)
                Vue.$toast.success("Nota fiscal cadastrada");
                resolve(response)
            }).catch(error => {
                Vue.$toast.error("Falha ao cadastrar a nota fiscal!");
                reject(error)
            })
        })
    },
    updateBill: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/bills/${payload.id}`, payload).then(response => {
                Vue.$toast.success("Nota fiscal atualizada!");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyBill: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/bills/${id}`).then(response => {
                Vue.$toast.error("Nota fiscal detelada!");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

}
const mutations = {

    SHOW_BILL: (state, payload) => {
        state.bill = payload
    },
    SHOW_BILLS: (state, payload) => {
        state.bills = payload
    },
    STORE_BILL: (state, payload) => {
        state.bill = payload
    }
}
const getters = {
    bill: state => {
        return state.bill
    },
    bills: state => {
        return state.bills
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}